import React from "react";
import { DataTable, HorizontalDivider, Table } from "@sscs/ui";
import { ExpandedRowDetails } from "../../../../ui";
import { NetworkingServicesList, NetworkingUrlValue, PolicyAudit, } from "../../../common";
const NetworkingRow = ({ networking, rowIndex, searchRegex, focused, onClick, }) => {
    const hasAudit = networking.audit.present;
    const hasServices = networking.services.length > 0;
    return (React.createElement(DataTable.ExpandedRow, { id: `networking-value-${rowIndex}`, focused: focused, onClick: onClick, disabled: !hasAudit && !hasServices },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(NetworkingUrlValue, { value: networking.value, classification: networking.classification.classification, servicesCount: networking.services.length, searchRegex: searchRegex })),
            React.createElement(Table.Cell, null, networking.classification.result
                ? networking.classification.result
                : "--"),
            React.createElement(Table.Cell, null, networking.tags.toSorted().map((tag) => (React.createElement("div", { key: tag }, tag))))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                hasAudit && React.createElement(PolicyAudit, { audit: networking.audit }),
                hasAudit && hasServices && React.createElement(HorizontalDivider, null),
                hasServices && (React.createElement(NetworkingServicesList, { services: networking.services }))))));
};
export default NetworkingRow;
//# sourceMappingURL=NetworkingRow.js.map